export default __webpack_public_path__ + "static/media/IOT-Img1.49370a40.svg";